import { useGetHasReadMutation } from "store/apis/infoModalsAPI"
import { INFO_MODAL_TYPE } from "store/apis/infoModalsAPI/types"

export const useCheckTutorial = () => {
  const [getHasReadMutation] = useGetHasReadMutation()

  const checkTutorial = async () => {
    const hasReadNewsFeed = await getHasReadMutation({
      type: INFO_MODAL_TYPE.TUTORIAL,
      lang: "en"
    })

    return hasReadNewsFeed.data
  }

  return checkTutorial
}
